module.exports = __webpack_public_path__ + "img/28.d7794670.jpg";